import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import AuthCallback from "./components/AuthCallback";
import { ElectionBanner } from "./components/ElectionBanner";
import HomePage from "./pages/HomePage";
import HowToVotePage from "./pages/HowToVotePage";
import QuizPage from "./pages/QuizPage";
import ComparisonPage from "./pages/ComparisonPage";
import ImpactCalculatorPage from "./pages/ImpactCalculatorPage";
import FactCheckerPage from "./pages/FactCheckerPage";
import PollTrackerPage from "./pages/PollTrackerPage";
import IssuesPage from "./pages/IssuesPage";
import HistoricalResultsPage from "./pages/HistoricalResultsPage";
import GlossaryPage from "./pages/GlossaryPage";
import ElectoratePage from "./pages/ElectoratePage";
import AdminPage from "./pages/AdminPage";
import AuthPage from "./pages/AuthPage";
import UserDashboard from "./pages/UserDashboard";
import ChatPage from "./pages/ChatPage";
import ScorecardPage from "./pages/ScorecardPage";
import VotingSimulatorPage from "./pages/VotingSimulatorPage";
import VolunteerPage from "./pages/VolunteerPage";
import PressKitPage from "./pages/PressKitPage";
import NewsPage from "./pages/NewsPage";
import PoliticiansPage from "./pages/PoliticiansPage";
import PoliticianProfilePage from "./pages/PoliticianProfilePage";
import PoliticianComparePage from "./pages/PoliticianComparePage";
import PoliciesPage from "./pages/PoliciesPage";
import PolicyDetailPage from "./pages/PolicyDetailPage";
import PromisesPage from "./pages/PromisesPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import SA2026Page from "./pages/SA2026Page";
import Federal2025Page from "./pages/Federal2025Page";
import VIC2026Page from "./pages/VIC2026Page";
import OnboardingPage from "./pages/OnboardingPage";
import NSW2027Page from "./pages/NSW2027Page";
import DonationsPage from "./pages/DonationsPage";

/** Scrolls to the top of the page on every route change. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js")
        .then((reg) => console.log("SW registered:", reg.scope))
        .catch((err) => console.warn("SW registration failed:", err));
    }
  }, []);

  return (
    <AuthProvider>
      <ThemeProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Standalone pages (no main Header) */}
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/dashboard" element={<UserDashboard />} />
              <Route path="/chat" element={<ChatPage />} />
              {/* Pages with main Header + Banner */}
              <Route
                path="*"
                element={
                  <>
                    <Header />
                    <ElectionBanner />
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/how-to-vote" element={<HowToVotePage />} />
                      <Route path="/quiz" element={<QuizPage />} />
                      <Route path="/compare" element={<ComparisonPage />} />
                      <Route path="/impact" element={<ImpactCalculatorPage />} />
                      <Route path="/fact-check" element={<FactCheckerPage />} />
                      <Route path="/polls" element={<PollTrackerPage />} />
                      <Route path="/issues" element={<IssuesPage />} />
                      <Route path="/history" element={<HistoricalResultsPage />} />
                      <Route path="/glossary" element={<GlossaryPage />} />
                      <Route path="/electorate" element={<ElectoratePage />} />
                      <Route path="/scorecard" element={<ScorecardPage />} />
                      <Route path="/news" element={<NewsPage />} />
                      <Route path="/simulator" element={<VotingSimulatorPage />} />
                      <Route path="/volunteer" element={<VolunteerPage />} />
                      <Route path="/press" element={<PressKitPage />} />
                      <Route path="/politicians" element={<PoliticiansPage />} />
                      <Route path="/politicians/compare" element={<PoliticianComparePage />} />
                      <Route path="/politicians/:id" element={<PoliticianProfilePage />} />
                      <Route path="/policies" element={<PoliciesPage />} />
                      <Route path="/policies/:id" element={<PolicyDetailPage />} />
                      <Route path="/promises" element={<PromisesPage />} />
                      <Route path="/leaderboard" element={<LeaderboardPage />} />
                      <Route path="/sa-2026" element={<SA2026Page />} />
                      <Route path="/vic-2026" element={<VIC2026Page />} />
                      <Route path="/nsw-2027" element={<NSW2027Page />} />
                      <Route path="/federal-2025" element={<Federal2025Page />} />
                      <Route path="/funding" element={<DonationsPage />} />
                      <Route path="/onboarding" element={<OnboardingPage />} />
                    </Routes>
                  </>
                }
              />
            </Routes>
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
